export const CONTACT = {
  whatsapp: "5566996183702",
  whatsappDisplay: "(66) 99618-3702",
  whatsappLink: "https://wa.me/5566996183702",
  instagram: "opadrinhorestaurante",
  instagramUrl: "https://www.instagram.com/opadrinhorestaurante",
  facebookUrl: "https://www.facebook.com/restauranteopadrinhosorriso",
  address: "R. Mato Grosso, 2565 - Kiosque 03 - Centro Norte, Sorriso - MT, 78890-000",
  addressShort: "R. Mato Grosso, 2565 - Centro Norte, Sorriso - MT",
};

export const HOURS = [
  { days: "Segunda a Sexta", time: "06:30 – 13:30  |  18:00 – 23:00" },
  { days: "Sábado e Domingo", time: "18:00 – 23:00" },
];

export const MENU_LINK = "https://opadrinho-cardapio-digital.lovable.app";

export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/pkan1ez8_logo_opadrinho_transparente.png",
  hero: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/tw1ydiyz_WhatsApp%20Image%202026-05-15%20at%2008.34.32.jpeg",
  historyCart: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/1mwi5pds_WhatsApp%20Image%202026-05-02%20at%2014.58.09.jpeg",
  historyFamily: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/z4175rlw_WhatsApp%20Image%202026-05-02%20at%2022.37.28.jpeg",
  banner28: "https://res.cloudinary.com/dmcpee99u/image/upload/v1781707382/28_anos_kvv3py.png",
  team: "https://res.cloudinary.com/dmcpee99u/image/upload/v1781707364/equipe_restaurante_jyn7kv.png",
  helenaSolo: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/l97ecn2v_Helena.jpeg",
  paolaSolo: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/jg80gvk5_Paola.jpeg",
  gallery: [
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/tw1ydiyz_WhatsApp%20Image%202026-05-15%20at%2008.34.32.jpeg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/9by65tki_ChatGPT%20Image%207%20de%20mai.%20de%202026%2C%2012_53_56.png",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/sfx2ygv8_WhatsApp%20Image%202026-06-02%20at%2010.08.52%20-%20Copia.jpeg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/bafpy7tb_WhatsApp%20Image%202026-06-09%20at%2011.53.32.jpeg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/vettfp1p_fora.jpeg",
    "https://res.cloudinary.com/dmcpee99u/image/upload/v1781810487/Gemini_Generated_Image__1_bubjod.png",
    "https://res.cloudinary.com/dmcpee99u/image/upload/v1781810451/WhatsApp_Image_2026-05-02_at_13.58.50_lg4vew.jpg",
    "https://res.cloudinary.com/dmcpee99u/image/upload/v1781810456/WhatsApp_Image_2026-05-02_at_13.58.49_1_kccyt0.jpg",
    "https://res.cloudinary.com/dmcpee99u/image/upload/v1781813827/WhatsApp_Image_2026-06-18_at_17.12.03_nc7ixe.jpg",
    "https://res.cloudinary.com/dmcpee99u/image/upload/v1781813817/WhatsApp_Image_2026-06-13_at_20.32.47_d0uxom.jpg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/c46v9dz1_burger-calabresa.jpeg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/17oozike_burger-bacon.jpeg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/wdn69oyp_batata-queijo-bacon.jpeg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/4sptvqqs_burger-classic.jpg",
    "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/pt2s98yx_burger-salada.jpg",
  ],
  // Family section
  family: [
    { src: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/d7dcf1sg_WhatsApp%20Image%202026-05-02%20at%2014.07.48.jpeg", caption: "Os pais e o filho — o começo de tudo" },
    { src: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/um1cwws2_WhatsApp%20Image%202026-05-02%20at%2014.20.31.jpeg", caption: "Crianças brincando, o carrinho ao fundo" },
    { src: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/secmpe4o_WhatsApp%20Image%202026-05-02%20at%2014.28.37.jpeg", caption: "Parceria de vida — Helena e o esposo" },
    { src: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/5u3pjd99_WhatsApp%20Image%202026-05-02%20at%2014.17.04.jpeg", caption: "Entregando sabor — gerações que ajudam" },
    { src: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/vzs6amwd_WhatsApp%20Image%202026-05-02%20at%2014.14.54.jpeg", caption: "Os pequenos da família" },
    { src: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/l97ecn2v_Helena.jpeg", caption: "Helena na cozinha" },
    { src: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/jg80gvk5_Paola.jpeg", caption: "Paola, sempre com um sorriso" },
    { src: "https://res.cloudinary.com/dmcpee99u/image/upload/v1781810977/ChatGPT_Image_7_de_mai._de_2026_12_56_44_sgai7s.png", caption: "Parceria de vida — Helena e Jó" },
    { src: "https://res.cloudinary.com/dmcpee99u/image/upload/v1781814965/familia_k0h0pq.jpg", caption: "A família toda — parceria e união só no O Padrinho" },
  ],
};

export const MENU_PDFS = {
  alaCarte: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/udfi3fly_cardapio%20imprimir.pdf",
  buffet: "https://customer-assets.emergentagent.com/job_ia-humanizada/artifacts/j0paztvk_imprimir%20cardapio%20buffet.pdf",
};

export const NAV_LINKS = [
  { label: "Início", href: "#inicio" },
  { label: "Nossa História", href: "#historia" },
  { label: "Cardápio", href: "#cardapio" },
  { label: "Galeria", href: "#galeria" },
  { label: "Localização", href: "#localizacao" },
  { label: "Contato", href: "#contato" },
];
